(function () {
  'use strict';

  var storageKey = 'hubCreatorCollegeAttributionV1';
  var parameterMap = {
    utm_source: 'source',
    utm_medium: 'medium',
    utm_campaign: 'campaign',
    utm_content: 'content',
    utm_term: 'term',
    cc_campus: 'campus',
    cc_path: 'path'
  };
  var productPaths = {
    'kids-creator-college-digital-first-creation': 'digital-first',
    'kids-creator-college-maker-creator-project': 'maker',
    'kids-creator-college-young-business-starter': 'business',
    'kids-creator-college-complete-creator-bundle': 'bundle'
  };

  function clean(value, limit) {
    if (value === undefined || value === null) return '';
    return String(value).replace(/[<>\r\n]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, limit || 160);
  }

  function readStored() {
    try {
      var value = window.localStorage.getItem(storageKey);
      return value ? JSON.parse(value) : {};
    } catch (error) {
      return {};
    }
  }

  function saveStored(value) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(value));
    } catch (error) {
      return;
    }
  }

  function combine(base, additions) {
    var result = {};
    var key;
    base = base || {};
    additions = additions || {};
    for (key in base) {
      if (Object.prototype.hasOwnProperty.call(base, key) && clean(base[key])) result[key] = clean(base[key]);
    }
    for (key in additions) {
      if (Object.prototype.hasOwnProperty.call(additions, key) && clean(additions[key])) result[key] = clean(additions[key]);
    }
    return result;
  }

  function fromLocation() {
    var values = {};
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (error) {
      return values;
    }
    Object.keys(parameterMap).forEach(function (parameter) {
      var value = clean(params.get(parameter));
      if (value) values[parameterMap[parameter]] = value;
    });
    if (Object.keys(values).length) {
      values.landing = clean(window.location.pathname, 220);
      values.capturedAt = new Date().toISOString();
    }
    return values;
  }

  function withDefaults(values) {
    values = combine({}, values);
    if (!values.source) values.source = 'urban-spirit-hub';
    if (!values.medium) values.medium = 'owned';
    if (!values.campaign) values.campaign = 'creator-college-evergreen';
    return values;
  }

  function valuesForLink(link) {
    var values = withDefaults(combine(readStored(), fromLocation()));
    values.campus = clean(link.getAttribute('data-cc-campus')) || values.campus;
    values.path = clean(link.getAttribute('data-cc-path')) || values.path;
    values.content = clean(link.getAttribute('data-cc-content')) || values.content;
    values.capturedAt = new Date().toISOString();
    return values;
  }

  function decorateLink(link) {
    var url;
    var values = valuesForLink(link);
    try {
      url = new URL(link.href, window.location.origin);
    } catch (error) {
      return values;
    }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return values;
    if (values.source) url.searchParams.set('utm_source', values.source);
    if (values.medium) url.searchParams.set('utm_medium', values.medium);
    if (values.campaign) url.searchParams.set('utm_campaign', values.campaign);
    if (values.content) url.searchParams.set('utm_content', values.content);
    if (values.term) url.searchParams.set('utm_term', values.term);
    if (values.campus) url.searchParams.set('cc_campus', values.campus);
    if (values.path) url.searchParams.set('cc_path', values.path);
    link.href = url.toString();
    return values;
  }

  function findNamedField(form, name) {
    var fields = form.querySelectorAll('input[name]');
    var match = null;
    Array.prototype.forEach.call(fields, function (field) {
      if (field.name === name) match = field;
    });
    return match;
  }

  function ensureHidden(form, name, value) {
    if (!value) return;
    var input = findNamedField(form, name);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = clean(value, 200);
  }

  function productHandle() {
    var parts = window.location.pathname.split('/').filter(function (part) { return part; });
    var productIndex = parts.indexOf('products');
    return productIndex > -1 && parts[productIndex + 1] ? parts[productIndex + 1] : '';
  }

  function productValues() {
    var handle = productHandle();
    if (!productPaths[handle]) return null;
    var values = withDefaults(combine(readStored(), fromLocation()));
    values.campus = values.campus || 'KCC';
    values.path = values.path || productPaths[handle];
    values.content = values.content || 'kcc-product-page';
    values.capturedAt = values.capturedAt || new Date().toISOString();
    saveStored(values);
    return values;
  }

  function enrichProductForm(form, values) {
    if (!form || !values) return;
    ensureHidden(form, 'properties[_cc_source]', values.source);
    ensureHidden(form, 'properties[_cc_medium]', values.medium);
    ensureHidden(form, 'properties[_cc_campaign]', values.campaign);
    ensureHidden(form, 'properties[_cc_content]', values.content);
    ensureHidden(form, 'properties[_cc_campus]', values.campus);
    ensureHidden(form, 'properties[_cc_path]', values.path);
  }

  function cartAttributes(values, checkoutIntent) {
    if (!values || !window.fetch) return;
    var endpoint = window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update.js';
    var attributes = {
      cc_source: clean(values.source),
      cc_medium: clean(values.medium),
      cc_campaign: clean(values.campaign),
      cc_content: clean(values.content),
      cc_campus: clean(values.campus),
      cc_path: clean(values.path)
    };
    if (checkoutIntent) attributes.cc_checkout_intent_at = new Date().toISOString();
    window.fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      keepalive: true,
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () { return; });
  }

  function fillInterestAttribution() {
    var values = withDefaults(combine(readStored(), fromLocation()));
    var mapping = { campaign: values.campaign, source: values.source, content: values.content || 'education-interest-form' };
    Object.keys(mapping).forEach(function (key) {
      var field = document.querySelector('[data-cc-attribution-field="' + key + '"]');
      if (field) field.value = clean(mapping[key]);
    });
  }

  function selectInterest(choice) {
    var select = document.querySelector('[data-cc-interest-select]');
    if (!select || !choice) return;
    Array.prototype.forEach.call(select.options, function (option) {
      if (option.value === choice) select.value = choice;
    });
    window.setTimeout(function () { select.focus(); }, 40);
  }

  function closestTarget(element, selector) {
    if (!element || element === document) return null;
    if (element.closest) return element.closest(selector);
    return null;
  }

  function initialize() {
    var incoming = fromLocation();
    if (Object.keys(incoming).length) saveStored(combine(readStored(), incoming));

    Array.prototype.forEach.call(document.querySelectorAll('[data-cc-link]'), function (link) {
      decorateLink(link);
    });

    var values = productValues();
    if (values) {
      Array.prototype.forEach.call(document.querySelectorAll('form[action*="/cart/add"]'), function (form) {
        enrichProductForm(form, values);
      });
    }
    fillInterestAttribution();

    document.addEventListener('click', function (event) {
      var campaignLink = closestTarget(event.target, '[data-cc-link]');
      if (campaignLink) saveStored(decorateLink(campaignLink));

      var interestLink = closestTarget(event.target, '[data-cc-interest-choice]');
      if (interestLink) {
        var interestValues = valuesForLink(interestLink);
        saveStored(interestValues);
        selectInterest(clean(interestLink.getAttribute('data-cc-interest-choice')));
        fillInterestAttribution();
      }

      var checkout = closestTarget(event.target, '[name="checkout"], a[href*="/checkout"]');
      if (checkout) cartAttributes(withDefaults(combine(readStored(), fromLocation())), true);
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.nodeName !== 'FORM') return;
      if (form.action && form.action.indexOf('/cart/add') > -1) {
        var currentValues = productValues();
        enrichProductForm(form, currentValues);
        cartAttributes(currentValues, false);
      }
      if (form.querySelector && form.querySelector('[name="checkout"]')) {
        cartAttributes(withDefaults(combine(readStored(), fromLocation())), true);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
